export const COLOR_TO_SEND = 'secondary';
export const COLOR_PUBLISHED = 'success';
export const COLOR_ERROR = 'error';